import ajax from "@/utils/request.js";

/*
获取列表
字段：cate_id 类型：int
1-雾森文化 2-悟生文化 3-戊申文化
*/
export const getCultureList = (data) => {
    return ajax.post("civilizations/getlist", data)
}

/*
获取详情
字段：
    name:名称
*/
export const getName = (data) => {
    return ajax.post("civilizations/getname", data)
}
/*
新增分享次数
字段：
    id:当前id
*/
export const addShare = (data) => {
    return ajax.post("civilizations/addshare", data)
}
/*
获取详情
字段：
    id(id)
    cate_id(分类id)
*/
export const getInfo = (data) => {
    return ajax.post("civilizations/getinfo", data)
}

/*
评分
参数名	必选	类型	说明
id	是	int	id
cate_id	是	int	1-雾森文化 2-悟生文化 3-戊申文化
score	是	int	分值
*/
export const score = (data) => {
    return ajax.post("civilizations/score", data)
}

/*
投资
参数名	必选	类型	说明
id	是	int	id
cate_id	是	int	1-雾森文化 2-悟生文化 3-戊申文化
amount	是	float	金额
*/
export const invest = (data) => {
    return ajax.post("civilizations/invest", data)
}


//支付
/*
typeid	是	int	1-支付宝 2-微信
no	是	string	订单号
*/
export const payApi = (data) => {
    return ajax.post("pay/pay", data)
}

//支付结果
export const payResultApi = (data) => {
    return ajax.post("pay/payresult", data)
}